import { IOption } from "Dashboard/domain/IOption";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { resourcesServices } from "../services/resource.service";

const ResourcesSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const resources = await resourcesServices.getResourcesSimpleList();
      const op = resources.map((resource) => {
        return {
          label: resource.nameWithIdentifier,
          value: resource.resourceId,
        };
      });

      setOptions(op);
      setIsLoading(false);
    }

    try {
      if (props.options) {
        setOptions(props.options);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options]);

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        setValueFunction(values[0]);
      } else {
        setValueFunction(undefined);
      }
    }
  }, [options, props.defaultValue, setValueFunction]);

  const getValue = () => {
    if (value) {
      return value;
    }
    return valueLocal;
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      menuPosition="fixed"
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      placeholder={props.placeholder ? props.placeholder : ""}
      loadingMessage={() => "Učitavanje..."}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      isDisabled={props.disabled === true}
      {...{ error: props.error }}
    />
  );
});

export default ResourcesSelect;
